/* ==========================================================================
   Section: DA Sticky ATC Bar
   - Appears when the "watch target" (buy box info column) exits the viewport
   - Mirrors the selected Skio plan + price
   - Submits the real product form on click
   ========================================================================== */

(function () {
  var wraps = document.querySelectorAll('[data-floating-cta]');
  if (!wraps.length) return;

  wraps.forEach(function (wrap) {
    var targetSelector = wrap.getAttribute('data-watch-target') || '.product__info-wrapper';
    var target = document.querySelector(targetSelector);
    if (!target) return;

    function setVisible(visible) {
      visible = window.matchMedia('(max-width: 989px)').matches || visible;
      wrap.classList.toggle('is-visible', visible);
      wrap.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            // DIRECTION MATTERS. `!isIntersecting` alone is true both when the target
            // is above the viewport AND when it is still below it, so the bar appeared
            // instantly at the top of the page, competing with the buy box the shopper
            // had not even reached yet.
            //
            // Only show it once the target has scrolled UP and out: bottom above the
            // viewport top. Below the fold, the shopper is still on their way to the
            // real button and does not need a second one.
            var above = entry.boundingClientRect.bottom <= 0;
            setVisible(!entry.isIntersecting && above);
          });
        },
        { threshold: 0 }
      );
      io.observe(target);
    } else {
      window.addEventListener('scroll', function () {
        setVisible(target.getBoundingClientRect().bottom <= 0);
      }, { passive: true });
    }

    // Mobile purchase tray uses the existing product form and Skio inputs.
    var picker = document.querySelector('.skio-plan-picker');
    var mobile = document.createElement('div');
    mobile.className = 'da-tray-options';
    mobile.innerHTML = '<button type="button" class="da-tray-toggle" aria-expanded="false" aria-controls="da-tray-panel"><span data-tray-label></span><span class="da-tray-chevron" aria-hidden="true"></span><span data-tray-summary></span></button><div id="da-tray-panel" class="da-tray-panel" hidden><p class="da-tray-heading">Choose your purchase</p><button type="button" data-tray-plan="once"></button><button type="button" data-tray-plan="sub"></button><label class="da-tray-quantity">Quantity <input type="number" min="1" step="1" value="1" aria-label="Tray quantity"></label><p class="da-tray-shipping">Free shipping on your first order.</p></div>';
    wrap.querySelector('.da-sticky-atc__inner').prepend(mobile);
    var toggle = mobile.querySelector('.da-tray-toggle');
    var panel = mobile.querySelector('.da-tray-panel');
    function closePanel() { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
    toggle.addEventListener('click', function () { panel.hidden = !panel.hidden; toggle.setAttribute('aria-expanded', String(!panel.hidden)); });
    document.addEventListener('click', function (e) { if (!mobile.contains(e.target)) closePanel(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { closePanel(); toggle.focus(); } });
    mobile.querySelectorAll('[data-tray-plan]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = picker && picker.querySelector(button.dataset.trayPlan === 'once' ? '[skio-one-time]' : '[skio-selling-plan-group]');
        if (input) input.click();
        closePanel(); toggle.focus(); requestAnimationFrame(syncTray);
      });
    });
    var trayQty = mobile.querySelector('input');
    trayQty.addEventListener('change', function () {
      var actual = document.querySelector('.product__info-container input[name="quantity"]');
      if (actual) { actual.value = String(Math.max(1, Math.floor(Number(trayQty.value) || 1))); actual.dispatchEvent(new Event('change', { bubbles: true })); }
      syncTray();
    });
    function syncTray() {
      if (!picker) return;
      var json = picker.querySelector('[skio-product-json]');
      if (!json) return;
      var product = JSON.parse(json.textContent);
      var id = document.querySelector('.product__info-container input[name="id"]');
      var variant = product.variants.find(function (v) { return id && String(v.id) === id.value; }) || product.variants[0];
      var qtyInput = document.querySelector('.product__info-container input[name="quantity"]');
      var qty = Number(qtyInput && qtyInput.value) || 1;
      trayQty.value = qty;
      var money = function (cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD' }).format(cents * qty / 100); };
      var plan = picker.querySelector('select[skio-selling-plans]');
      var allocation = variant.selling_plan_allocations.find(function (a) { return plan && String(a.selling_plan_id) === plan.value; }) || variant.selling_plan_allocations[0];
      var selected = picker.querySelector('input[name="selling_plan"]');
      var sub = !!(selected && selected.value);
      var once = mobile.querySelector('[data-tray-plan="once"]');
      var subscription = mobile.querySelector('[data-tray-plan="sub"]');
      once.textContent = 'One-time purchase · ' + money(variant.price);
      once.setAttribute('aria-pressed', String(!sub));
      subscription.hidden = !allocation;
      if (allocation) {
        var first = allocation.price_adjustments[0].price;
        var renewal = allocation.price_adjustments[1] ? allocation.price_adjustments[1].price : first;
        subscription.textContent = 'Subscribe · ' + money(first) + ' first order. Then ' + money(renewal) + ' per delivery. Skip or cancel anytime.';
        subscription.setAttribute('aria-pressed', String(sub));
      }
      mobile.querySelector('[data-tray-label]').textContent = sub ? 'Subscribe' : 'One-time';
      mobile.querySelector('[data-tray-summary]').textContent = money(sub && allocation ? allocation.price : variant.price) + (sub ? ' first' : '');
      toggle.setAttribute('aria-label', (sub ? 'Subscription, first order ' : 'One-time purchase, ') + money(sub && allocation ? allocation.price : variant.price) + ', quantity ' + qty + '. Change purchase options');
      var real = document.querySelector('.product-form__submit');
      var sticky = wrap.querySelector('[data-sticky-submit]');
      if (real && sticky) { sticky.disabled = real.disabled; sticky.textContent = real.disabled ? real.textContent.trim() : 'Add to cart'; }
    }
    document.addEventListener('change', function () { requestAnimationFrame(syncTray); });
    window.addEventListener('resize', function () { setVisible(target.getBoundingClientRect().bottom <= 0); });
    setVisible(target.getBoundingClientRect().bottom <= 0);

    // Mirror selected Skio plan title + price into the bar
    var planEl = wrap.querySelector('[data-sticky-plan]');
    var priceEl = wrap.querySelector('[data-sticky-price]');
    var chipEl = wrap.querySelector('[data-sticky-chip]');
    var compareEl = wrap.querySelector('[data-sticky-compare]');

    function parseMoney(text) {
      var m = text.replace(/,/g, '').match(/\$?\s*(\d+(?:\.\d+)?)/);
      return m ? parseFloat(m[1]) : null;
    }

    function cleanText(el) {
      var clone = el.cloneNode(true);
      clone.querySelectorAll('script, style, .skio-save').forEach(function (n) {
        n.remove();
      });
      return clone.textContent.replace(/\s+/g, ' ').trim();
    }

    function syncFromSkio() {
      syncTray();
      var selected = document.querySelector('.skio-group-container--selected');
      if (!selected) return;
      var title = selected.querySelector('.skio-group-title');
      var price = selected.querySelector('.skio-price');
      if (title && planEl) planEl.textContent = cleanText(title);
      if (price && priceEl) priceEl.textContent = cleanText(price);

      // Compare price + save chip: derive from the qty-scaled compare var or one-time price
      var isSub = !!selected.querySelector('[skio-selling-plan-group]');
      var current = price ? parseMoney(cleanText(price)) : null;
      var compare = null;
      if (isSub) {
        var varVal = selected.style.getPropertyValue('--da-compare').replace(/"/g, '').trim();
        compare = varVal ? parseMoney(varVal) : null;
        if (!compare) {
          var qtyEl = document.querySelector('.quantity__input');
          var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
          compare = 44.99 * qty;
        }
      }
      if (compareEl && chipEl) {
        if (isSub && current && compare && compare > current) {
          compareEl.textContent = '$' + compare.toFixed(2);
          compareEl.hidden = false;
          chipEl.textContent = 'SAVE ' + Math.round((1 - current / compare) * 100) + '%';
          chipEl.hidden = false;
        } else {
          compareEl.hidden = true;
          chipEl.hidden = true;
        }
      }
    }

    // Watch for plan changes (Skio toggles classes on click)
    var picker = document.querySelector('.skio-plan-picker');
    if (picker && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        syncFromSkio();
      });
      mo.observe(picker, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
    // Re-sync when quantity tiles change the price
    document.addEventListener('da:qty-change', function () {
      // Prices update in the same tick; sync on next frame
      requestAnimationFrame(syncFromSkio);
    });

    // Initial sync (Skio renders async, retry briefly)
    var tries = 0;
    var t = setInterval(function () {
      syncFromSkio();
      if (++tries > 10 || document.querySelector('.skio-group-container--selected')) clearInterval(t);
    }, 500);

    // Submit the real product form
    var submitBtn = wrap.querySelector('[data-sticky-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        var realBtn = document.querySelector('.product-form__submit');
        if (realBtn && !realBtn.disabled) {
          realBtn.click();
        } else {
          // Fallback: scroll back to the buy box
          var el = document.querySelector('product-info') || target;
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  });
})();
